import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

export const Times = (props) => {
  return <FontAwesomeIcon faIcon={faTimes} {...props} />
}
